import ReactGA from 'react-ga';

const analyticsTagTrigger = ({ga, category, action, label}) => ReactGA[ga]({
        category: category,
        action: action,
        label: label
    });

export default analyticsTagTrigger;